import { render, staticRenderFns } from "./add-share-add-receiver.vue?vue&type=template&id=0f15d6ce&"
import script from "./add-share-add-receiver.js?vue&type=script&lang=js&"
export * from "./add-share-add-receiver.js?vue&type=script&lang=js&"
import style0 from "./add-share-add-receiver.css?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardActions,VCardText})
